module.exports = __webpack_public_path__ + "img/yw-one.d5a582ae.png";